import { isValidDateFormat } from "./helper";

jQuery(function ($) {
  if ($(".add-answer-form").length <= 0) {
    return;
  }

  const addDataButtonHTML = (addUrl, text = "Add data") => {
    return `<a href="${addUrl}" class="admin-action-button add-answer-button !px-2 !rounded-2xl whitespace-nowrap btn btn-s--small btn-c--green" target="_blank">${text}</a>`;
  };

  $(".add-answer-form:not(.has-year-tabs)").on("submit", function (e) {
    e.preventDefault();
    const form = $(this);
    const datatable = $(form.data("target"));
    const input = form.find("input[type=text]");
    const value = input.val();
    const inputFormat = input.attr("name");

    form.find(".form-error").remove();

    if (!isValidDateFormat(value, inputFormat)) {
      form.append(
        '<div class="form-error text-red-500 text-desktopXS mt-2">Invalid value format</div>'
      );
      return;
    }

    // check if new value is already exist in the table
    const matchingCells = [];
    datatable.find("td[data-year]").each(function () {
      const cellYear = $(this).attr("data-year");
      if (cellYear === value) {
        matchingCells.push(this);
      }
    });

    if (matchingCells.length > 0) {
      form.append(
        '<div class="form-error text-red-500 text-desktopXS mt-2">Value already exist!</div>'
      );
      return;
    }

    if (datatable.length === 0) {
      form.append(
        '<div class="form-error text-red-500 text-desktopXS mt-2">Something went wrong! Please contact the administrator for assistance.</div>'
      );
      return;
    }

    const placeholderRow = datatable.find(".placeholder-answer-row");
    const newRow = placeholderRow.clone();
    newRow
      .removeClass("placeholder-answer-row !hidden")
      .addClass("new-answer-row !bg-ideaListGrey100");
    newRow.find("td[data-year]").each(function () {
      $(this).attr("data-year", value);
      $(this).text(value);
    });
    newRow.find("td[data-qid]").each(function () {
      const qid = $(this).data("qid");
      const cid = $(this).data("cid");

      let addUrl = `/node/add/answer?qid=${qid}&cid=${cid}`;
      if (inputFormat === "date") {
        addUrl += `&date=${value}`;
      } else {
        addUrl += `&y=${value}`;
      }

      const buttonHTML = addDataButtonHTML(addUrl);
      $(this).html(buttonHTML);
    });

    newRow.insertBefore(placeholderRow);

    // Auto scroll to the newly added row
    datatable.parent(".table-container").scrollTop(datatable.height());

    input.val(""); // Reset value
  });

  $(".add-answer-form.has-year-tabs").on("submit", function (e) {
    e.preventDefault();
    const form = $(this);
    const yearTabs = form.parents(".years-tabs");
    const datatable = $(form.data("target"));
    const input = form.find("input[type=text]");
    const value = input.val();
    const inputFormat = input.attr("name");

    form.find(".form-error").remove();

    if (!isValidDateFormat(value, inputFormat)) {
      form.append(
        '<div class="form-error text-red-500 text-desktopXS mt-2">Invalid value format</div>'
      );
      return;
    }

    // check if new value is already exist
    const matchingCells = [];
    yearTabs.find(".vtabs-toggles [data-year]").each(function () {
      const cellYear = $(this).attr("data-year");
      if (cellYear === value) {
        matchingCells.push(this);
      }
    });

    if (matchingCells.length > 0) {
      form.append(
        '<div class="form-error text-red-500 text-desktopXS mt-2">Value already exist!</div>'
      );
      return;
    }

    if (
      datatable.length === 0 ||
      datatable.find(".value-cell").length === 0 ||
      datatable.find(".admin-actions-cell").length === 0
    ) {
      form.append(
        '<div class="form-error text-red-500 text-desktopXS mt-2">Something went wrong! Please contact the administrator for assistance.</div>'
      );
      return;
    }

    const activeYearTabToggle = yearTabs.find(".vtab-toggle.active");
    const newYearTabToggle = activeYearTabToggle.clone();
    const activeYearToggleLabel = activeYearTabToggle.find("[data-year]");

    const queryParams = {
      country: activeYearToggleLabel.attr("data-cid"),
      database_theme: activeYearToggleLabel.attr("data-tid"),
      year: activeYearToggleLabel.attr("data-year"),
    };
    const queryString = $.param(queryParams);

    // Recreate active year toggle content with the same structure of sibling toggles
    let newContent = "";
    if (!activeYearTabToggle.hasClass("new-year-tab")) {
      newContent += `<a href="/data-tools/data/country?${queryString}" class="show-fake-loading">`;
    }
    newContent += `<div class="vtab-toggle-label" data-year="${queryParams.year}" data-cid="${queryParams.country}" data-tid="${queryParams.database_theme}">${queryParams.year}</div>`;
    if (!activeYearTabToggle.hasClass("new-year-tab")) {
      newContent += `</a>`;
    }
    activeYearTabToggle.html(newContent);
    activeYearTabToggle.removeClass("active");

    // Update content of new year tab toggle
    const newYearToggleLabel = newYearTabToggle.find("[data-year]");
    newYearTabToggle.addClass("new-year-tab");
    newYearToggleLabel.attr("data-year", value);
    newYearToggleLabel.attr("data-cid", queryParams.country);
    newYearToggleLabel.attr("data-tid", queryParams.database_theme);
    newYearToggleLabel.text(value);
    activeYearTabToggle.parent().append(newYearTabToggle);

    // Empty out every other cell
    datatable.find(".value-cell").each(function () {
      $(this).empty();
    });

    // Construct new add button on the actions cells
    datatable.find(".admin-actions-cell").each(function () {
      const qid = $(this).data("qid");
      const cid = $(this).data("cid");
      const addUrl = `/node/add/answer?qid=${qid}&cid=${cid}&y=${value}`;
      const buttonHTML = addDataButtonHTML(addUrl, `Add ${value} data`);
      $(this).html(buttonHTML);
    });

    input.val(""); // Reset value
    // form.hide(); // Don't allow to add more than 1 year tab at a time
  });

  $(document).on("click", ".database-results .add-answer-button", function (e) {
    $(this).hide();
  });
});
